import { ModuleAccessGuard } from '@/components/ModuleAccessGuard';

export default function Meters() {
  return (
    <ModuleAccessGuard moduleId="onboarding">
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Meters</h1>
          <p className="text-muted-foreground mt-2">
            Manage customer meters and their readings.
          </p>
        </div>
        <div className="text-center text-muted-foreground">
          Meters management interface coming soon.
        </div>
      </div>
    </ModuleAccessGuard>
  );
}